import "./BaseModal.css";

interface BaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width?: string;
  height?: string;
}

const BaseModal: React.FC<BaseModalProps> = ({
  isOpen,
  onClose,
  children,
  height = "auto",
}) => {
  if (!isOpen) return null;

  return (
    <div className="gx-modal-overlay" onClick={onClose}>
      <div
        className="gx-modal-content"
        style={{ height }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default BaseModal;
